import { Breadcrumb, Button, Input, Space, Table } from "antd"
import React, { memo, useEffect, useMemo, useState } from "react"
import styles from './index.module.less';
import { equipmentTypeToText } from "@/common/filter"
import { Link } from "react-router-dom"
import { CreateEquipment } from "./Item/CreateEquipment"
import { useRequest } from "ahooks"
import { deleteEquipment, getProjectEquipments, OrganizationEquipmentService } from "@/services/project/equipment/equipment.service"
import { SearchOutlined } from "@ant-design/icons"
import { SvgElem } from "@/components/SvgElem/SvgElem"

const { Search } = Input;

interface EquipmentListProps {
  orgId?: number
}

export const EquipmentList = memo((props: EquipmentListProps) => {
  const { orgId } = props

  const service = useMemo(() => {
    if (orgId) {
      return {
        getEquipments: () => OrganizationEquipmentService.getEquipments(orgId),
        deleteEquipment: (id) => OrganizationEquipmentService.deleteEquipment(id)
      }
    }
    return {
      getEquipments: getProjectEquipments,
      deleteEquipment: deleteEquipment
    }
  }, [orgId])

  const { data: equipments = [], loading, refresh } = useRequest(() => service.getEquipments(), {
    refreshDeps: [service]
  })
  const [searchText, setSearchText] = useState('')

  const data = useMemo(() => {
    if (!searchText) return equipments;
    return equipments.filter(item => {
      return item.name.toLowerCase().includes(searchText.toLowerCase())
    })
  }, [equipments, searchText])

  const onDelete = async (id: number) => {
    await service.deleteEquipment(id)
    refresh()
  }

  const onSearch = (val: string) => {
    setSearchText(val)
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: (type) => {
        return equipmentTypeToText(type)
      }
    },
    {
      title: 'Image',
      dataIndex: 'image',
      key: 'image',
      render: (image) => {
        if (!image) return '-'
        return <SvgElem imageStr={image} className={styles.equipmentImg} svgClassName="svg-node-icon" />
      }
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      render: (_, item) => {
        return <Space>
          <Button>
            <Link to={`${item.id}/basic`}>
              Edit
            </Link>
          </Button>
          <Button onClick={() => onDelete(item.id)} danger>
            Delete
          </Button>
        </Space>
      }
    },
  ];

  return <div className={styles.container}>
    <Breadcrumb>
      <Breadcrumb.Item>Equipment List</Breadcrumb.Item>
    </Breadcrumb>
    <div className="flex-space-btw mt-1">
      <Input
        onInput={(e) => onSearch(e.currentTarget.value)}
        addonAfter={<SearchOutlined />}
        style={{width: 300}}
        placeholder="Search by equipment name"
      />
      <Button type='primary' onClick={() => {
        CreateEquipment.show({onSuccess: () => refresh(), orgId})
      }}>Create Equipment</Button>
    </div>
    <div className="tableContainer mt-2">
      <Table columns={columns} dataSource={data} size="small" bordered/>
    </div>
  </div>
})